<template>
  <section id="Optouts" class="section-item">
    <h1>{{ $t("title.optouts") }}</h1>

    <section id="api-Optouts-PutOptoutsId">
      <h2>{{ $t("title.update_number") }}</h2>
      <p>{{ $t("optouts.update_optout_number_method") }}</p>
      <div class="">
        <div class="put type">PUT</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/optouts/:id</code></pre>
      </div>
      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>

      <pre>
        <code class="language-json">{
  "mobile_number": "11912345678"
}</code>
      </pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.optouts_update_id") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.optouts_new_mobile_number") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Optouts-PostOptouts">
      <h2>{{ $t("title.create_optout") }}</h2>
      <p>{{ $t("optouts.create_optout_method") }}</p>
      <div class="">
        <div class="post type">POST</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/optouts</code></pre>
      </div>
      <div class="code-toggle">
        <button
          @click="selectedTabCreate = 'json-wpp'"
          :class="{ active: selectedTabCreate === 'json-wpp' }"
        >
          JSON (Whatsapp)
        </button>
        <button
          @click="selectedTabCreate = 'json-email'"
          :class="{ active: selectedTabCreate === 'json-email' }"
        >
          JSON (E-mail)
        </button>
      </div>

      <pre v-if="selectedTabCreate === 'json-wpp'">
        <code class="language-json">{
  "numbers": ["38999554433", "38999332211"],
  "keyword_id": "68c136f7-e950-4b82-814f-be218f176dfa",
  "channel": "whatsapp"
}</code>
      </pre>

      <pre v-if="selectedTabCreate === 'json-email'">
        <code class="language-json">{
  "channel": "email",
  "emails": "vctormartins1@gmail.com,teste@email.com",
  "keyword_id": "cd2c0c54-2ba8-4b64-9401-cdd070688857"
}</code>
      </pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>numbers</td>
            <td>Array</td>
            <td>{{ $t("table.optouts_numbers") }}</td>
          </tr>
          <tr>
            <td>emails</td>
            <td>Array</td>
            <td>{{ $t("table.optouts_emails") }}</td>
          </tr>
          <tr>
            <td>keyword_id</td>
            <td>String</td>
            <td>{{ $t("table.optouts_keyword_id") }}</td>
          </tr>
          <tr>
            <td>channel</td>
            <td>String</td>
            <td>{{ $t("table.optouts_channel") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Optouts-DeleteOptoutsId">
      <h2>{{ $t("title.exclude_id") }}</h2>
      <p>{{ $t("optouts.delete_optout_by_id_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/optouts/:id</code></pre>
      </div>

      <div class="code-toggle">
        <button class="json">JSON (Whatsapp)</button>
      </div>
      <pre>
        <code class="language-json">{
  "mobile_number": "11912345678"
}</code>
      </pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{ $t("table.optouts_id") }}</td>
          </tr>
          <tr>
            <td>mobile_number</td>
            <td>String</td>
            <td>{{ $t("table.optouts_mobile_number") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Optouts-DeleteOptouts">
      <h2>{{ $t("title.delete_optouts") }}</h2>
      <p>{{ $t("optouts.delete_optouts_method") }}</p>
      <div class="">
        <div class="delete type">DELETE</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/optouts</code></pre>
      </div>

      <div class="code-toggle">
        <button class="json">JSON</button>
      </div>
      <pre v-if="selectedTab === 'json'">
        <code class="language-json">{
  "ids": ["f70180e2-95a2-4b49-92a4-5cfad83bc3bd", "df576318-8913-4589-a42e-50564bbe7397"]
}</code>
      </pre>

      <h3>{{ $t("general.field") }}</h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("general.field") }}</th>
            <th>{{ $t("general.type") }}</th>
            <th>{{ $t("general.description") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>ids</td>
            <td>Array</td>
            <td>{{ $t("table.optouts_ids") }}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Optouts-GetOptouts">
      <h2>{{ $t("title.list_optouts") }}</h2>
      <p>{{ $t("optouts.list_optouts_method") }}</p>
      <div class="">
        <div class="get type">GET</div>
        <pre> <code class="url language-bash">https://{{ whitelabel?.api_domain }}/v1/optouts</code></pre>
      </div>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "OptoutsComponent",
  data() {
    return {
      selectedTab: "json",
      selectedTabCreate: "json-wpp",
    };
  },
  mounted() {
    this.highlightCode();
    console.log(this.$t("general.to"));
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
    selectedTabCreate() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
